import config from '../../../config'
import http from './http-util'

class ReceiptSummaryApi {
  static sendReceiptSummary = (paymentId, index, email) => token => {
    return http.post(
      token,
      `${config.receiptSummaryServiceUrl}/receipts/payment/${paymentId}/payment_logs/${index}/send`,
      JSON.stringify(email),
    )
  }
}

export default ReceiptSummaryApi
